import store from "redux/Store";

export const localRefreshTrackingMeta = (obj, isNew=false, additional=null) => {

    const {
        user, user: { id: userid},
      } = store.getState();

    const { firstName, lastName, imageUrl } = user.credentials.orgID
        ? user.credentials.orgs.find((v) => v.id === user.credentials.orgID)
        : {};

    if(additional)
     obj = {...obj, ...additional}

    if(isNew)
    {
        obj.createdBy = userid
        obj.createdByName = firstName + ' ' + lastName;
        obj.createdByImageUrl = imageUrl;
        obj.createdAt = new Date().toISOString();

    }

    obj.updatedBy = userid
    obj.updatedByName = firstName + ' ' + lastName;
    obj.updatedByImageUrl = imageUrl;
    obj.updatedAt = new Date().toISOString();

    return obj;

}

export const localRefreshTrackingMetaInbox = (obj, isNew=false, additional=null) => {

    const {
        user, user: {email},
      } = store.getState();

    const { firstName, lastName, imageUrl } = user.credentials.orgID
        ? user.credentials.orgs.find((v) => v.id === user.credentials.orgID)
        : {};

    if(additional)
     obj = {...obj, ...additional}

    if(isNew)
    {
        obj.createdBy = email
        obj.createdByName = firstName + ' ' + lastName;
        obj.createdByImageUrl = imageUrl;
        obj.createdAt = new Date().toISOString();

    }

    obj.updatedBy = email
    obj.updatedByName = firstName + ' ' + lastName;
    obj.updatedByImageUrl = imageUrl;
    obj.updatedAt = new Date().toISOString();

    return obj;

}

export const localRefreshTrackingMetaWorkspace = (
  obj,
  isNew = false,
  additional = null
) => {
  const {
    user,
    user: { id: userid },
  } = store.getState();

  const { firstName, lastName } = user.credentials.orgID
    ? user.credentials.orgs.find((v) => v.id === user.credentials.orgID)
    : {};

  if (additional) obj = { ...obj, ...additional };

  if (isNew) {
    obj.createdBy = userid;
    obj.createdByName = firstName + " " + lastName;
    obj.createdAt = new Date().toISOString();
  }

  obj.updatedBy = userid;
  obj.updatedByName = firstName + " " + lastName;
  obj.updatedAt = new Date().toISOString();

  return obj;
};